import React, { useEffect, useState } from "react";
import {
  Box,
  Switch,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  FormControlLabel,
  Alert,
  Pagination,
  useTheme,
  useMediaQuery,
  Stack,
} from "@mui/material";
import { useSelector } from "react-redux";
import StockService from "../services/StockService";

const Stock = () => {
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const [stockFollowId, setStockFollowId] = useState(null);
  const [stockFollow, setStockFollow] = useState(null);
  const [stocks, setStocks] = useState([]);
  const [isFollowing, setIsFollowing] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPage, setTotalPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const fetchStockFollow = async () => {
    try {
      const response = await StockService.fetchStockFollow(authUserId);
      if (response.data.data.length > 0) {
        setStockFollowId(response.data.data[0].id);
        setIsFollowing(response.data.data[0].use);
        setStockFollow(response.data.data[0]);
      }
    } catch (error) {
      console.error("Stok takip verisi çekilirken hata oluştu:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStock = async () => {
    try {
      const response = await StockService.fetchStock(stockFollowId, page);
      setStocks(response.data.data);
      setTotalPage(response.data.recordsTotal);
    } catch (error) {
      console.error("Stok verisi çekilirken hata oluştu:", error);
    }
  };

  const handleToggleFollow = async () => {
    try {
      setLoading(true);
      if (!stockFollowId) {
        await StockService.addStockFollow({
          userId: authUserId,
          use: true,
          ia: true,
        });
      } else {
        await StockService.updateStockFollow({
          id: stockFollowId,
          userId: authUserId,
          use: !isFollowing,
          updateDate: new Date(),
          createDate: stockFollow.createDate,
          ia: true,
        });
      }
      await fetchStockFollow();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Takip durumu güncellenirken hata oluştu:", error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    fetchStockFollow();
  }, []);

  useEffect(() => {
    if (stockFollowId && isFollowing) {
      fetchStock();
    }
  }, [stockFollowId, isFollowing, page]);
  console.log(stocks);
  return (
    <Box
      sx={{
        mt: { xs: 2, sm: 3, md: 5 },
        px: { xs: 1, sm: 2, md: 3 },
        py: { xs: 1, sm: 2 },
        backgroundColor: "#f5f5f5",
        borderRadius: 2,
        minHeight: { xs: "90vh", sm: "80vh" },
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: { xs: 1.5, sm: 2, md: 3 },
          mb: { xs: 2, sm: 3 },
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: { xs: 2, sm: 0 },
            mb: { xs: 2, sm: 3 },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{ width: 4, height: 24, backgroundColor: "#b71c1c", mr: 1 }}
            />
            <Typography
              variant="h6"
              color="black"
              sx={{
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                mt: 0.5,
                fontSize: { xs: "1rem", sm: "1.25rem" },
              }}
            >
              Stok takip paneli
            </Typography>
          </Box>
          <FormControlLabel
            control={
              <Switch
                checked={isFollowing}
                onChange={handleToggleFollow}
                color="primary"
                size={isMobile ? "small" : "medium"}
              />
            }
            label={
              <Typography sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                {isFollowing ? "Stok Takibi Aktif" : "Stok Takibini Başlat"}
              </Typography>
            }
          />
        </Box>

        {loading ? (
          <Typography sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}>
            Yükleniyor...
          </Typography>
        ) : isFollowing ? (
          stocks.length == 0 ? (
            <>
              <Alert
                severity="info"
                sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
              >
                Kayıtlı Stok verisi bulunamadı daha sonra tekrar kontrol ediniz
              </Alert>
            </>
          ) : (
            <>
              <TableContainer
                component={Paper}
                sx={{
                  overflowX: "auto",
                  "& .MuiTable-root": {
                    minWidth: { xs: 650, sm: 750, md: 900 },
                  },
                }}
              >
                <Table
                  aria-label="stok tablosu"
                  size={isMobile ? "small" : "medium"}
                >
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                      <TableCell
                        sx={{
                          whiteSpace: "nowrap",
                          fontSize: { xs: "0.75rem", sm: "0.875rem" },
                        }}
                      >
                        ID
                      </TableCell>
                      <TableCell
                        sx={{
                          whiteSpace: "nowrap",
                          fontSize: { xs: "0.75rem", sm: "0.875rem" },
                        }}
                      >
                        Oluşturma Tarihi
                      </TableCell>
                      <TableCell
                        sx={{
                          whiteSpace: "nowrap",
                          fontSize: { xs: "0.75rem", sm: "0.875rem" },
                        }}
                      >
                        Güncelleme Tarihi
                      </TableCell>
                      <TableCell
                        sx={{
                          whiteSpace: "nowrap",
                          fontSize: { xs: "0.75rem", sm: "0.875rem" },
                        }}
                      >
                        Sipariş No
                      </TableCell>
                      <TableCell
                        sx={{
                          whiteSpace: "nowrap",
                          fontSize: { xs: "0.75rem", sm: "0.875rem" },
                        }}
                      >
                        Ürün Barkodu
                      </TableCell>
                      <TableCell
                        sx={{
                          whiteSpace: "nowrap",
                          fontSize: { xs: "0.75rem", sm: "0.875rem" },
                        }}
                      >
                        Mevcut Stok
                      </TableCell>
                      <TableCell
                        sx={{
                          whiteSpace: "nowrap",
                          fontSize: { xs: "0.75rem", sm: "0.875rem" },
                        }}
                      >
                        Güncellendi mi?
                      </TableCell>
                      <TableCell
                        sx={{
                          whiteSpace: "nowrap",
                          fontSize: { xs: "0.75rem", sm: "0.875rem" },
                        }}
                      >
                        Hata Mesajı
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {stocks.map((stock) => (
                      <TableRow key={stock.id}>
                        <TableCell
                          sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                        >
                          {stock.id}
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                        >
                          {new Date(stock.createDate).toLocaleString("tr-TR")}
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                        >
                          {new Date(stock.createDate).toLocaleString("tr-TR")}
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                        >
                          {stock.orderNumber}
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                        >
                          {stock.productBarcode}
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                        >
                          {stock.currentQuantity}
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                        >
                          {stock.updateSuccessful
                            ? "✅ Başarılı"
                            : "❌ Başarısız"}
                        </TableCell>
                        <TableCell
                          sx={{
                            maxWidth: { xs: 150, sm: 200 },
                            wordBreak: "break-word",
                            fontSize: { xs: "0.75rem", sm: "0.875rem" },
                          }}
                        >
                          {stock.errorMessage || "-"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: { xs: 1, sm: 2 },
                    mb: { xs: 1, sm: 2 },
                  }}
                >
                  <Pagination
                    count={Math.ceil(totalPage / 10)}
                    page={page}
                    onChange={handleChangePage}
                    color="primary"
                    size={isMobile ? "small" : "medium"}
                    sx={{
                      "& .MuiPaginationItem-root": {
                        fontSize: { xs: "0.75rem", sm: "0.875rem" },
                      },
                    }}
                  />
                </Box>
              </TableContainer>
              <Alert
                sx={{
                  mt: { xs: 1, sm: 2 },
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                }}
                severity="info"
              >
                Eğer sistemde XML&apos;iniz mevcutsa, bu özelliği kullanmayınız.
              </Alert>
            </>
          )
        ) : (
          <Alert
            severity="info"
            sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
          >
            Stok takip tablosunu görüntülemek için takip düğmesini aktif hale
            getirin.
          </Alert>
        )}
      </Paper>
    </Box>
  );
};

export default Stock;
